export const APP = {
  PRODUCT_NAME: 'BirdAI',
  PRODUCT_CLOUD: 'BrightClassCloud',
};
